<template>
  <button @click="exportToExcel" class="exports d-flex align-center ga-2">
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10M4.66667 6.66667L8 10M8 10L11.3333 6.66667M8 10V2"
        stroke="#666666"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <span>{{ $t("export") }}</span>
  </button>
  <button
    @click="toggleActivityDrawer"
    class="exports d-flex align-center ga-2"
  >
    <ActivityLogIcon />

    <span>{{ $t("activity_log") }}</span>
  </button>
  <activity-drawer
    :drawer="activityDrawer"
    @update:drawer="activityDrawer = $event"
    :type="'Lead'"
  />
</template>

<script>
import * as XLSX from "xlsx";
import activityLog from "./Activites/ActivityLog.vue";
import ActivityLogIcon from "@/components/icons/ActivityLogIcon.vue";
export default {
  name: "TopHead",
  props: ["leads"],
  components: { "activity-drawer": activityLog, ActivityLogIcon },
  data() {
    return {
      activityDrawer: false,
    };
  },
  methods: {
    exportToExcel() {
      const worksheet = XLSX.utils.json_to_sheet(this.leads);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");
      XLSX.writeFile(workbook, "Leads.xlsx");
    },
    toggleActivityDrawer() {
      this.activityDrawer = !this.activityDrawer;
    },
  },
};
</script>
<style scoped>
.exports {
  padding: 5px 10px;
  border-radius: 5px;
  transition: all 0.3s ease;
}
.exports:hover {
  background-color: rgb(211, 211, 211);
}
</style>
